import React, { useState, useEffect } from "react";
import { SmsNotificationStyle } from "./SmsNotifications.styled";
import TopBar from "../../components/TopBar/TopBar";
import Footer from "../../components/footer/Footer";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import { HeadingStyle } from "../../styles/HeadingStyles";
import { TextErrorStyle } from "../../styles/ErrorStyles";
import { SmsNotificationvalidationSchema } from "../../validations/SmsNotificationValidation";
import { toast } from "react-toastify";
import Controller from "../../common/controller";
import api from "../../api/configAxios";
import { useReload } from "../../context/ReloadContext";
import { useDB } from "../../context/DynamoDBContext";
import { useQueryClient, useQuery } from "@tanstack/react-query";
import { getConfigurations } from "../../api/ConfigurationApi";

const SmsNotifications = () => {
  const [beaconMAC, setBeaconMAC] = useState("");
  const [error, setError] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [number, setNumber] = useState("");
  const { reload } = useReload();
  const { dynamoDBClient } = useDB();
  const queryClient = useQueryClient();
  const [enableApi, setEnableApi] = useState(false);
  const [disableIcons, setDisableIcons] = useState(false);
  const [data, setData] = useState([]);
  const [userConfig, setUserConfig] = useState({});

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (dynamoDBClient) {
      setEnableApi(true);
    } else {
      setEnableApi(false);
    }
  }, [dynamoDBClient]);

  useEffect(() => {
    if (reload) {
      queryClient.fetchQuery(["getSmsNotificationConfigurations"]);
    }
  }, [reload]);

  const resetForm = () => {
    setBeaconMAC("");
    setNumber("");
  };
  const handleError = (type) => {
    if (type === "getSmsNotificationConfigurations") {
      toast.error("Error while loading Configuration", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  const { data: configData, status: configStatus } = useQuery({
    queryKey: ["getSmsNotificationConfigurations"],
    queryFn: () => getConfigurations(dynamoDBClient, "SmsNotification"),
    enabled: enableApi,
    onSuccess: (data) => {
      console.log(data);
      if (data.length > 0) {
        const config = data[0];
        setUserConfig(config);
        setData(config.ConfigurationData);
      } else {
      }
      setEnableApi(true);
    },
    onError: (error) => {
      console.log("getSmsNotificationConfigurations :", error);
      handleError("getSmsNotificationConfigurations");
    },
  });
  const Errors = (err) => {
    setError(err[0].split(":")[1]);
  };

  const SendNotification = async () => {
    try {
      var response = await api.post(
        `${Controller.dynamoDB}/SendSmsNotification`,
        {
          phoneNumber: number,
          beaconMAC: beaconMAC,
        }
      );
      setError("");
      setBtnDisable(false);
      if (response.data.status === 200) {
        toast("Notification Sent Successfully");
        resetForm();
      } else {
        toast.error(response.data.message, {
          bodyClassName: "notification-div-error",
          progressClassName: "progress-bar-error",
        });
      }
    } catch (error) {
      toast.error("An Error has ocurred", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
      setBtnDisable(false);
    }
  };

  const removeUser = async (mac) => {
    try {
      setDisableIcons(true);
      const val = data.filter((item) => item.beaconMAC != mac);
      var params = {
        TableName: "Configurations",
        Key: {
          ConfigurationId: userConfig.ConfigurationId,
          ModeType: "SmsNotification",
        },
        UpdateExpression: "SET ConfigurationData = :val ",
        ExpressionAttributeValues: {
          ":val": val,
        },
        ReturnValues: "ALL_NEW",
      };
      const result = await dynamoDBClient.update(params).promise();
      toast("Successfully Removed User");
      setData(val);
      setDisableIcons(false);
    } catch (error) {
      toast.error("Error has Ocurred.Try Again", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    setDisableIcons(false);
  };

  const sendSMSNotifications = async (val) => {
    setError("");
    setBtnDisable(true);
    const formData = {
      beaconMAC: beaconMAC,
      phoneNumber: number,
    };

    const exists = data.some((item) => item.beaconMAC == beaconMAC);
    if (exists) {
      setError("This Beacon is already associated with user.");
      setBtnDisable(false);
      return;
    }

    await SmsNotificationvalidationSchema.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        if (val === 1) {
          const val = [...data, formData];
          addUser(val);
        }

        if (val === 2) {
          SendNotification();
        }
      })
      .catch((err) => {
        setBtnDisable(false);
        Errors(err.errors);
      });
  };

  const addUser = async (val) => {
    try {
      var params = {
        TableName: "Configurations",
        Key: {
          ConfigurationId: userConfig.ConfigurationId,
          ModeType: "SmsNotification",
        },
        UpdateExpression: "SET ConfigurationData = :val ",
        ExpressionAttributeValues: {
          ":val": val,
        },
        ReturnValues: "ALL_NEW",
      };
      const result = await dynamoDBClient.update(params).promise();
      toast("Successfully Added User");
      setData(val);
    } catch (error) {
      toast.error("Error has Ocurred.Try Again", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    setBtnDisable(false);
    resetForm();
  };

  return (
    <SmsNotificationStyle>
      <TopBar authorized={true} />
      <MainBodyStyle>
        <HeadingStyle>SMS Notifications</HeadingStyle>
        <div className="configurationCardWidth configurationCard">
          <table className="table-div">
            <tbody>
              <tr className="row-div">
                <td>
                  <div className="field-div">Beacon MAC:</div>
                </td>
                <td>
                  <input
                    value={beaconMAC}
                    onChange={(e) => {
                      setError("");
                      setBeaconMAC(e.target.value.toUpperCase());
                    }}
                    type="text"
                    id="beaconMAC"
                    maxLength={30}
                    placeholder="Enter Beacon MAC"
                    className="form-control mt-1 input-field"
                  />
                </td>
              </tr>
              <tr className="row-div">
                <td>
                  <div className="field-div">Phone Number:</div>
                </td>
                <td>
                  <input
                    value={number}
                    onChange={(e) => {
                      setError("");
                      setNumber(e.target.value);
                    }}
                    type="text"
                    id="number"
                    maxLength={30}
                    placeholder="Enter Phone Number"
                    className="form-control mt-1 input-field"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="btn_view">
            <button
              type="submit"
              className={"btn form-button"}
              disabled={btnDisable}
              onClick={() => sendSMSNotifications(1)}
            >
              Save User
            </button>
            <button
              type="submit"
              className={"btn form-button"}
              disabled={btnDisable}
              onClick={() => sendSMSNotifications(2)}
            >
              Send Notification
            </button>
          </div>

          {error !== "" && <TextErrorStyle>{error}</TextErrorStyle>}
        </div>
        <div>
          <div className="table-container">
            <div className="table-div2">
              <table className="table table-hover">
                <thead className="table-head">
                  <tr>
                    <th scope="col" className="table-item">
                      #
                    </th>
                    <th scope="col" className="table-item">
                      BeaconMAC
                    </th>
                    <th scope="col" className="table-item">
                      Phone Number
                    </th>
                    <th scope="col" className="table-item">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {configStatus === "loading" || reload ? (
                    <tr>
                      <td colSpan={4}>
                        <p className="table-loading">Loading...</p>
                      </td>
                    </tr>
                  ) : data.length === 0 ? (
                    <tr>
                      <td colSpan={4}>
                        <p className="table-loading">No User Added</p>
                      </td>
                    </tr>
                  ) : (
                    data.map((item, index) => (
                      <tr key={index}>
                        <th scope="row" className="table-item">
                          {index + 1}
                        </th>
                        <td className="table-item table-item2">
                          {item.beaconMAC}
                        </td>
                        <td className="table-item table-item2">
                          {item.phoneNumber}
                        </td>
                        <td className="table-item">
                          <i
                            title="Delete"
                            className={
                              disableIcons
                                ? "bi bi-trash delete-icon disable-icon"
                                : "bi bi-trash delete-icon"
                            }
                            onClick={() => {
                              removeUser(item.beaconMAC);
                            }}
                          />
                        </td>
                        <td></td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </MainBodyStyle>
      <Footer style="footer" />
    </SmsNotificationStyle>
  );
};

export default SmsNotifications;
